import { Navigate, Outlet } from 'react-router-dom';
import { Layout } from './Layout';
import { UrlsFront } from '../../../constants/urls';
import { SESSION_KEY } from '../../../constants/data';

export const AuthorizedLayout = () => {
  const checkedUser = localStorage.getItem(SESSION_KEY) != null;

  return <Layout>{checkedUser ? <Outlet /> : <Navigate to={UrlsFront.LogIn} />}</Layout>;
};
